import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const badgeDefinition: ComponentDefinition = {
  id: 'badge',
  name: 'Badge',
  category: 'UI',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/badge.svg',
  variables: {
    text: {
      type: 'Text',
      displayName: 'Text',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
  },
} as const;
